<div class="card h-100 mb-0">
  <div class="card-heading border bottom" *ngIf="headerContent || title">
    <h2 *ngIf="title" class="card-title inline-block pdd-top-5">{{ title }}</h2>
    <ng-content select="[headerTemplate]"></ng-content>
  </div>
  <div class="card-block">
    <ng-content></ng-content>
  </div>
</div>
